"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constantsClasses_1 = require("../data/constantsClasses");
var Richtext = /** @class */ (function () {
    function Richtext() {
        this.richtexts = document.querySelectorAll('[data-richtext]');
        if (this.richtexts && !(this.richtexts.length > 0))
            return;
        for (var i = 0; i < this.richtexts.length; i++) {
            var subheadlines = this.richtexts[i].querySelectorAll(".".concat(constantsClasses_1.CLASS_SUBHEADLINE));
            if (subheadlines && !(this.richtexts.length > 0))
                continue;
            for (var j = 0; j < subheadlines.length; j++) {
                if (subheadlines[j].nextElementSibling)
                    continue;
                subheadlines[j].parentElement.nextElementSibling.classList.add(constantsClasses_1.CLASS_MT_0);
            }
        }
    }
    return Richtext;
}());
exports.default = Richtext;
